export const currentDashboard = state => state.currentDashboard

export const isEditing = state => !!state.currentDashboard.uuid

export const loading = state => state.loading

export const sortedTabs = state => state.currentDashboard.tabs.filter(tab => !tab.draft)

export const activeTabUuid = state => state.activeTabUuid

export const activeTab = (state, getters) => {
  return getters.sortedTabs.find(tab => tab.uuid === state.activeTabUuid) || getters.sortedTabs[0] || null
}

export const sortedChartsOfActiveTab = (state, getters) => {
  const tab = getters.activeTab
  if (!tab) {
    return []
  }
  return tab.charts || []
}

export const sortedGlobalFilters = state => state.currentDashboard.filters

export const quickFiltersOfTab = state => tabUuid => {
  const tab = state.currentDashboard.tabs.find(t => t.uuid === tabUuid)
  return tab ? (tab.quickFilters || []) : []
}
